import { useState, useContext, useMemo, useRef, useEffect } from 'react';
import moment from 'moment';

import { LoginContext } from '../context/login-context';

import useProtectedQuery from '../hooks/use-protected-query';
import useProtectedMutation from '../hooks/use-protected-mutation';

// import VOCClient from "../VOCClient";
import RebatesClient from '../RebatesClient';

export default function useInvoices(props) {
    const { state: userData } = useContext(LoginContext);

    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [showInvoice, setShowInvoice] = useState(false);

    const {
        selectedFarms,
        startDate,
        endDate,
        // selectedStratAcctIds
    } = props

    // useEffect(() => {
    //     if(selectedInvoice?.newInvoiceNeedsReload){
    //         console.log(`selectedInvoice ${JSON.stringify(selectedInvoice)}`)
    //         refetchInvoices()
    //     }
    // }, [selectedInvoice]);

    const {
        data: invoices,
        isLoading: invoicesLoading,
        isRefetching: invoicesRefetching,
        error: invoicesError,
        refetch: refetchInvoices
    } = useProtectedQuery({
        queryKey: ['get_invoices',],
        queryFn: async () => {
 
            // if(!startDate || !endDate) {console.log('dates not complete');return}
            const hasQueryParams = (startDate && endDate) || selectedFarms
            let url = `/api/invoice/get-invoices${hasQueryParams?'?':''}`;

            url += startDate && endDate ? `start=${startDate.toISOString()}&end=${endDate.toISOString()}` : ``

            const selectedFarmIds = selectedFarms?.map(f=>f.id)
          url += selectedFarmIds?.length ? `&farm_acct_ids=${selectedFarmIds?.join(',')}` : ''


            const result = await RebatesClient.standardFetch(url)

            if (result.response.ok) {
                const invoices = result.body.invoices
                if (selectedInvoice && !selectedInvoice?.isNewUpload) {
                    //new uploads already get full invoice upload response
                    ////todo would be better if use-invoices did upload so we could track state there when recieving new invoice here
                    const inv = invoices?.filter(inv => inv.id == selectedInvoice.id)[0]
                    setSelectedInvoice(inv)
                }
                return result.body.invoices;
            }
            else {
                throw new Error("Error getting invoices");
            }

        },
    });




    const {
        mutate: handleUpdateInvoiceStatus,
        error: invoiceStatusUpdateError,
        isSuccess: statusSaveSuccess,
        isPending: statusSaving,

    } = useProtectedMutation({
        queryKey: ['update_invoice_status',],
        mutationFn: async (invoice) => {

            const response = await RebatesClient.updateInvoiceStatus(invoice)

            if (!response.ok) {
                throw new Error("Error saving invoice status");
            }

            refetchInvoices()
        }
    });


    const {
        mutate: handleUpdateInvoiceDetails,
        error: invoiceDetailsUpdateError,
        isSuccess: updateInvoiceDetailsComplete,
        isPending: updatingInvoiceDetails,

    } = useProtectedMutation({
        queryKey: ['update_invoice_details',],
        mutationFn: async (invoice) => {

            
            const response = await RebatesClient.updateInvoiceDetails(invoice)

            if (!response.ok) {
                throw new Error("Error saving invoice details");
            }

            refetchInvoices()
        }
    });




    const {
        mutate: handleSaveInvoiceItem,
        error: invoiceItemSaveError,
        isSuccess: saveSuccess,
        isPending: itemSaving,

    } = useProtectedMutation({
        queryKey: ['save_invoice_item',],
        mutationFn: async (item) => {

            const response = await RebatesClient.saveInvoiceItem(item)

            if (!response.ok) {
                throw new Error("Error saving invoice");
            }

        

            refetchInvoices()
        }
    });

    const {
        mutate: handleDeleteInvoiceItem,
        error: invoiceItemDeleteError,
        isSuccess: deleteSuccess,
        isPending: itemDeleting,
        // status: asdfa

    } = useProtectedMutation({
        queryKey: ['delete_invoice_item'],
        mutationFn: async (itemId) => {
            const response = await RebatesClient.deleteInvoiceItem(itemId)

            if (!response.ok) {
                throw new Error("Error deleting invoice item");
            }

            refetchInvoices()
        }
    });

    const {
        mutateAsync: handleBulkDeleteInvoiceItems,
        error: bulkInvoiceItemDeleteError,
        isPending: bulkItemDeleting,

    } = useProtectedMutation({
        queryKey: ['bulk_delete_invoice_items'],
        mutationFn: async (item_ids) => {
            const response = await RebatesClient.bulkDeleteInvoiceItems(item_ids)

            if (!response.ok) {
                throw new Error("Error bulk deleting invoice items");
            }

            const body = await response.json();
            refetchInvoices()
            return body;
        }
    });



    const {
        mutate: handleDeleteInvoice,
        error: invoiceDeleteError,
        isSuccess: deleteInvoiceSuccess,
        isPending: invoiceDeleting,

    } = useProtectedMutation({
        queryKey: ['delete_invoice'],
        mutationFn: async (invoiceId) => {
            const response = await RebatesClient.deleteInvoice(invoiceId)

            if (!response.ok) {
                throw new Error("Error deleting invoice");
            }

            refetchInvoices()
        }
    });


    const {
        mutate: handleBulkUpdateInvoiceStatus,
        error: bulkInvoiceStatusUpdateError,
        isSuccess: bulkStatusSaveSuccess,
        isPending: bulkStatusSaving,

    } = useProtectedMutation({
        queryKey: ['bulk_update_invoice_status',],
        mutationFn: async ({ invoice_ids, status }) => {

            const response = await RebatesClient.bulkUpdateInvoiceStatus(invoice_ids, status)

            if (!response.ok) {
                throw new Error("Error bulk updating invoice status");
            }

            refetchInvoices()
        }
    });


    return {
        
        handleBulkUpdateInvoiceStatus,
        bulkInvoiceStatusUpdateError,
        bulkStatusSaveSuccess,
        bulkStatusSaving,

        invoices,
        refetchInvoices,
        handleSaveInvoiceItem,
        handleDeleteInvoiceItem,
        handleBulkDeleteInvoiceItems,
        bulkInvoiceItemDeleteError,
        bulkItemDeleting,
        handleUpdateInvoiceStatus,
        handleDeleteInvoice,
        handleUpdateInvoiceDetails,
        invoiceDetailsUpdateError,
        updateInvoiceDetailsComplete,
        updatingInvoiceDetails,

        selectedInvoice,
        setSelectedInvoice,
        showInvoice,
        setShowInvoice,



        //todo separate errors and isSuccess
        error: invoicesError || invoiceItemSaveError || invoiceItemDeleteError || bulkInvoiceItemDeleteError,
        isSuccess: saveSuccess || deleteSuccess,
        isLoadingInvoices: invoicesLoading,
        isRefetchingInvoices: invoicesRefetching,
        isSaving: itemSaving,
        isDeleting: itemDeleting || bulkItemDeleting
       
        



    }
}
